import { render } from "./HorizontalScroller.vue?vue&type=template&id=3e6c50aa&scoped=true"
import script from "./HorizontalScroller.vue?vue&type=script&lang=js"
export * from "./HorizontalScroller.vue?vue&type=script&lang=js"

import "./HorizontalScroller.vue?vue&type=style&index=0&id=3e6c50aa&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6c50aa"]])

export default __exports__